import styled from '@emotion/styled';

import ProductItemList from './helpers/ProductItemList';
import pathToContent from './helpers/path_to_content';
import retrieveImage from './helpers/retrieveImage';
import { truncateText } from '../../../../helpers/text_truncate_helper';
import Theme from '../../../../themes';
import IconChevronRight from '../../../ComponentLibrary/icons/icon-chevron-right';
import RichText from '../../../OC/PageBuilder/RichText';
import { H4 } from '../../../OC/oc-h';
import ImageAttribution from '../../../OC/oc-image-attribution';
import { connectLocation } from '../../../location/LocationConnectors';

const LinkContainer = styled.a`
  display: flex;
  gap: 16px;
  text-decoration: none;
  width; 100%;

  &:hover {
    color: inherit;
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

const ItemImageContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
`;

const ItemImage = styled.img`
  flex-shrink: 0;
  height: 270px;
  object-fit: cover;
  width: 480px;

  @media (max-width: 767px) {
    height: unset;
    width: 100%;
  }
`;

const StyledAttribution = styled(ImageAttribution)`
  @media screen and (min-width: 768px) {
    bottom: 20px;
    right: 20px;
  }
`;

const TextContainer = styled.div`
  align-self: start;
  flex-direction: column;
  width: 100%;
`;

const Heading = styled(H4)`
  && {
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
  }
`;

const PseudoLink = styled.span`
  align-items: center;
  color: black;
  display: inline-flex;
  font-size: 18px;
  gap: 16px;
  line-height: 22px;

  &:hover {
    color: ${Theme.colors.brand};
  }
`;

const ProductListItem = connectLocation(({ ...product }) => {
  const listItemImage = retrieveImage(product);
  const attribution = listItemImage?.attribution;
  const generalContent = product.metadata?.settings?.general;
  const properName = generalContent?.proper_name;
  const itemText = generalContent?.long_description || generalContent?.short_description;
  const itemUrl = pathToContent(product);

  return (
    <LinkContainer href={itemUrl}>
      {listItemImage && (
        <ItemImageContainer>
          <ItemImage src={listItemImage?.file} alt={properName} />
          <StyledAttribution copy={attribution} />
        </ItemImageContainer>
      )}
      <TextContainer>
        <Heading>{properName}</Heading>
        <RichText content={truncateText(itemText, 320)} />
        <PseudoLink>
          <span>View Product</span>
          <IconChevronRight height="14px" width="8px" />
        </PseudoLink>
      </TextContainer>
    </LinkContainer>
  );
});

export default ProductItemList({
  common: {
    type: 'Product::Fleetwood',
  },
  search: {
    name: 'Fleetwood Products',
    preview: result => ({
      heading: result.metadata?.settings?.general?.proper_name || result.name,
    }),
  },
  list: {
    availableIn: ['www.fleetwoodusa.com'],
    name: 'Products - Fleetwood',
    attributeSet: {
      name: 'Product Attributes',
      path: '',
    },
    dataset: 'products_fleetwood',
    view: ProductListItem,
    enableSearch: true,
  },
});
